import { routes } from '../routes';
import { getDeliveryDataForProduct, getSeasonForProduct } from '../selectors';
import { generateProductId } from './products';
import { getTranslateByScope } from '../i18n';

export const translate = getTranslateByScope('app.productList');

const addAllProductsToast = (context, history) => context.actions.setToast({
  title: translate('multipleProductsAdded.title'),
  text: translate('multipleProductsAdded.description'),
  action: {
    text: translate('toCurrentOrderText'),
    onClick: () => history.push(routes.currentOrder),
  },
});
export const onAddAllProducts = ({
  products,
  tischOffensiveId,
  context,
  currentOrder,
  history,
  onAdd,
}) => {
  const allProducts = products.map((p) => {
    const {
      includesDeliveryPeriod,
      defaultDeliveryDate,
    } = getDeliveryDataForProduct(context, p.n);
    return {
      id: generateProductId(),
      tischOffensiveId,
      number: p.n,
      season: getSeasonForProduct({
        number: p.n,
        orderSeason: currentOrder.doc.season,
        context,
      }),
      createdAt: new Date(),
      deliveryDate: includesDeliveryPeriod ? defaultDeliveryDate : null,
    };
  });
  context.actions.onAddMultipleProductsToOrder({
    order: currentOrder.doc,
    products: allProducts,
    onSuccess: () => addAllProductsToast(context, history),
  });
  onAdd();
};
